import { formatDate } from "../../../../../features/dataFormatFunctions/dataFormatter"
import { formatDateToLocalFormat } from "src/shared/format/date";
import { useMemo } from "react";
import { useMapTooltipDisplayData } from "../useMapTooltipDisplayData";

// RoadAccidents
export default function RAContent() {
    const { data, displayData } = useMapTooltipDisplayData()
    const { Date: AccidentDate, Time: AccidentTime, DateAndTime } = data ?? {}
    const { AccidentTypeString, DeathRoll, WoundedCount } = displayData ?? {}

    const formattedDate = useMemo(() => {
        const fromDate = AccidentDate ? formatDateToLocalFormat(AccidentDate) : null;
        if (fromDate) return fromDate;
        const fromDateTime = DateAndTime ? formatDateToLocalFormat(DateAndTime) : null;
        return fromDateTime ?? null;
    }, [AccidentDate, DateAndTime]);

    const formattedTime = (() => {
        if (AccidentTime) {
            let t = String(AccidentTime).replace('Z', '');
            const m = t.match(/^(\d{2}:\d{2})/);
            return m ? m[1] : t;
        }
        const fromDateTime = DateAndTime ? formatDate(DateAndTime)?.split(' ')[1] : null;
        return fromDateTime ?? null;
    })();

    return (
        <>
            <div className="tooltip-info-row">Дата: {formattedDate ?? "Не известно"}</div>
            <div className="tooltip-info-row">Время: {formattedTime ?? "Не известно"}</div>
            <div className="tooltip-info-row">Вид ДТП: {AccidentTypeString ?? "Не известно"}</div>
            <div className="tooltip-info-row">Число погибших: {DeathRoll ?? "Не известно"}</div>
            <div className="tooltip-info-row">Число раненых: {WoundedCount ?? "Не известно"}</div>
        </>
    )
}
